import styles from './admin-orders.module.scss';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { UseTableHook } from '../../requestUtils';
import PageTitle from '../../page-title/page-title';
import OrdersGrid from '../orders-grid/orders-grid';
import { IOrders } from '../../_models/orders';
import OrdersGridSkeleton from '../orders-grid/orders-grid-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface OrdersProps { }

export function Orders(props: OrdersProps) {
  const { t } = useTranslation();
  const { data, onDateChange, isLoading, dateRange } = UseTableHook<IOrders>(`admin/orders`)

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.orders")} subtitle={`(${t("standard.admin")})`} />
            {isLoading ?
              <OrdersGridSkeleton isLoading /> :
              <OrdersGrid
                orders={data}
                onDateChange={onDateChange}
                dateRange={dateRange}
              />}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Orders;